import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PageHero from './PageHero';
import EventsGrid from './EventsGrid';
import Pagination from './Pagination';
import ContactCTAStrip from './ContactCTAStrip';
import { getEventsData } from '../data/eventsData';

const Events = () => {
  const { t } = useTranslation();
  const allEvents = useMemo(() => getEventsData(t), [t]);

  const ITEMS_PER_PAGE = 4;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const totalPages = Math.ceil(allEvents.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentEvents = allEvents.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="events-page">
      <PageHero title="Events" />
      <section className="events-section section-padding">
        <div className="container">
          <EventsGrid events={currentEvents} />
          <Pagination 
            currentPage={currentPage} 
            totalPages={totalPages} 
            onPageChange={handlePageChange} 
          />
        </div>
      </section>
      <ContactCTAStrip />
    </div>
  );
};

export default Events;
